export enum ScheduledEventErrorMessage {
    NoEvent = 'no scheduled event data'
}
